import { ErrorMessage, Field } from "formik";
import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";

type TextInputProps = {
  value?: string | number | undefined;
  type: string;
  name: string;
  placeholder?: string;
  label?: string;
  className?: string;
  disabled?: boolean | undefined;
  handleChange?: (e: React.ChangeEvent<any>) => void;
  required?: boolean;
};
export default function TextInput({
  name,
  value,
  type,
  placeholder,
  label,
  className,
  disabled,
  handleChange,
  required
}: TextInputProps) {
  return (
    <FormGroup className="mt-2">
      {label && !required && <FormLabel>{label}</FormLabel>}
      {label && required &&  <FormLabel>{label} <span style={{color: 'red'}}>*</span></FormLabel>}
      <FormControl
        as={Field}
        name={name}
        className={className}
        value={value}
        onChange={handleChange}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
      />
      <ErrorMessage className="text-error" name={name} component="div"/>
    </FormGroup>
  );
}
